import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Pictures from "../DetailsComponents/Pictures";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BottomPictures from "../DetailsComponents/BottomPictures";
import Description from "../DetailsComponents/Description";
import StrongPoint from "../DetailsComponents/StrongPoint";
import img1 from "../../../assets/Image/Details1/Photo1.jpg";
import img3 from "../../../assets/Image/Details1/Photo3.jpg";
import img4 from "../../../assets/Image/Details1/Photo4.jpg";
import img5 from "../../../assets/Image/Details1/Photo5.jpg";
import img6 from "../../../assets/Image/Details1/Photo6.jpg";
import img7 from "../../../assets/Image/Details1/Photo7.jpg";
import img8 from "../../../assets/Image/Details1/Photo8.jpg";
import img9 from "../../../assets/Image/Details1/Photo9.jpg";
import img10 from "../../../assets/Image/Details1/Photo10.jpg";
import img11 from "../../../assets/Image/Details1/Photo11.jpg";
import img12 from "../../../assets/Image/Details1/Photo12.jpg";
import {
    faArrowLeft,
    faCar,
    faLocation,
    faTree,
} from "@fortawesome/free-solid-svg-icons";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

const images = [img1, img6, img3, img4, img5];
const images2 = [
    img1,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
];

const DetailsId1 = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);
    const navigate = useNavigate();

    const handleImageClick = (index) => {
        setPhotoIndex(index);
        setIsOpen(true);
    };

    return (
        <div>
            <div className="px-48 xl:px-28 lg:px-24 md:px-14 sm:px-6">
                <button
                    className="w-10 h-10 mt-1 bg-customGray text-black rounded-full p-2 tansition duration-300 ease-in-out transform hover:text-customPink hover:bg-white hover:scale-125"
                    onClick={() => navigate("/acheter-louer")}
                >
                    <FontAwesomeIcon
                        className="m-auto text-base"
                        icon={faArrowLeft}
                    />
                </button>
                <Pictures
                    title="Maison en centre ville de Poitiers"
                    images={images}
                    onImageClick={handleImageClick}
                />
                <BottomPictures
                    place="Rue du Maréchal Foch Poitiers"
                    state="Sous-offre"
                />
                <h5 className="text-2xl mt-20 mb-10">Points forts du bien</h5>
                <div className="mb-20 flex justify-around items-center reveal-left lg:flex-wrap gap-8 md:flex-wrap md:gap-8 sm:flex-wrap sm:gap-8">
                    <StrongPoint icon={faLocation} text="Localisation" />
                    <StrongPoint icon={faTree} text="Extérieur" />
                    <StrongPoint
                        icon={faCar}
                        text="Garage & Place de parking"
                    />
                </div>
                <Description
                    text={`L'Immobilier sur Mesure vous propose cette belle maison fin 19ème de 190m2 habitable située en plein coeur du centre ville et à 3min à pied des commerces et de la Mairie de Poitiers.
                        Calme, lumineuse et très bien disposée, la maison se compose au rez de chaussée d'un double séjour et d'une cuisine aménagée et équipée ouvrant sur un patio.
                        Au 1er et 2ème étage, vous trouverez sur chacun des niveaux, deux spacieuses chambres avec rangements intégrés, salle de bain et WC séparé.
                        Dernier étage avec coin bureau, salle de jeu, bibliothèque, salle télé et mezzanine avec nombreux rangements (possibilité création 5ème chambre et 3eme salle d’eau).
                        En sous-sol, cave très saine avec espace modulable et une partie cave à vin.
                        Le gros point fort du bien est un garage fermé à proximité immédiate de la maison et une place de parking extérieur complète ce bien rare sur le secteur.
                        Possibilité d'acquérir la maison sans le garage et le parking.`}
                />
            </div>
            {isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
                    <button
                        className="absolute top-4 right-4 text-white text-2xl"
                        onClick={() => setIsOpen(false)}
                    >
                        &times;
                    </button>
                    <div className="w-8/12 md:w-3/4 lg:w-3-4 sm:w-full">
                        <Carousel
                            selectedItem={photoIndex}
                            showThumbs={true}
                            showStatus={false}
                            swipeable={true}
                            autoPlay={true}
                            interval={4000}
                            infiniteLoop
                            useKeyboardArrows
                            onChange={(index) => setPhotoIndex(index)}
                        >
                            {images2.map((img, index) => (
                                <div key={index}>
                                    <img
                                        src={img}
                                        alt={`Show ${index + 1}`}
                                        className="object-contain w-full"
                                    />
                                </div>
                            ))}
                        </Carousel>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DetailsId1;
